<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >
    <el-row :gutter="16" class="filter__container"> 
      <el-col :lg="11" :md="16" :sm="24">
        <el-form-item :prop="fields.name.name">
          <div class="form__item__label__slot" slot="label">
            <span v-text="!isPropertyNBA ? fields.name.label : i18n('entities.base.fields.name')"></span>
            <el-button v-if="model.name" type="text" @click="resetFieldFilter({ fieldKey: 'name'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-player"
            :placeholder="!isPropertyNBA ? fields.name.label : i18n('entities.base.fields.name')"
            v-model="model[fields.name.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col>

      <el-col :lg="11" :md="16" :sm="24">
        <el-form-item :prop="fields.country.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.country.label}}</span>
            <el-button v-if="model.country" type="text" @click="resetFieldFilter({ fieldKey: 'country'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-select
            :placeholder="fields.country.label"
            v-model="model[fields.country.name]"
            @change="doFilter"
            filterable
          >
            <el-option :value="undefined">--</el-option>
            <i class="icon-family" slot="prefix"></i>
            <el-option
              :key="option.id"
              :label="option.label"
              :value="option.id"
              v-for="option in supportedCountries"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- <el-col :lg="8" :md="16" :sm="24">
        <el-form-item :prop="fields.managers.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.managers.label}}</span>
            <el-button type="text" @click="resetFieldFilter({ fieldKey: 'managers'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <app-autocomplete-many-input
            :fetchFn="fields.managers.fetchFn"
            :manage="currentManage"
            v-model="model.managers"
            :fetchFilter="doFilter"
            prefix-icon="icon-cup"
          >
          </app-autocomplete-many-input>
        </el-form-item>
      </el-col> -->
      
      <el-col :lg="2" :md="16" :sm="24">
        <div class="filter-buttons">
          <el-button
            :disabled="loading"
            @click="doResetFilter"
            icon="icon-undo"
            circle
          />
        </div>
      </el-col>
    </el-row>

  </el-form>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { SubpropertyModel } from '@modules/subproperty/subproperty-model';
import _ from 'lodash';
import supportedCountries from '@enums/supportedCountries.json';
import { i18n } from '@shared/i18n';

const { fields } = SubpropertyModel;


const filterSchema = new FilterSchema([
  fields.name,
  fields.country,
]);

export default {
  name: 'app-subproperty-list-filter',

  data() {
    return {
      rules: filterSchema.rules(),
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'subproperty/list/loading',
      filter: 'subproperty/list/filter',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    fields() {
      return fields;
    },

    supportedCountries() {
        return this.fields.country.options.filter(({ id }) => {
            return supportedCountries.some(countryId => countryId === id);
        });
    },
  },

  async mounted() {
    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    );
    //return this.doFilter();
  },

  methods: {
    ...mapActions({
      doReset: 'subproperty/list/doReset',
      doFetch: 'subproperty/list/doFetch',
    }),

    async doResetFilter() {
      this.model = filterSchema.initialValues();
      this.$refs.form.clearValidate();
      
      this.doReset();
      return this.doFetch();
    },

    async resetFieldFilter({ fieldKey }) {
      if (this.model[`${fieldKey}`]) this.model[`${fieldKey}`] = null;
      this.doFilter();
    },

    debounceInput: _.debounce(function () {
      this.doFilter();
    }, 500),

    async doFilter() {
      const currentManage = this.currentManage;

      if (currentManage != null && currentManage.property && currentManage.property.id) {
        const propertyId = currentManage.property.id;
        this.model.propertyId = propertyId;
      }

      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = filterSchema.cast(this.model);
      return this.doFetch({
        filter,
      });
    },
    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

<style scoped>
</style>
